export const revealReferee = (data: any) => data?.map((d: any) => d?.person?.refereeProfile) || [];
